
<v-dialog
    v-model="touched"
    max-width="480"
    persistent
    scrollable
>
    <template #activator="{ on, attrs }">
        <slot v-bind="{ on, attrs }"></slot>
    </template>

    <v-card>
        <v-card-title class="customized-primary white--text">{{ value.exists() ? t('user_card_title_update_comment') : t('user_card_title_create_comment') }}</v-card-title>

        <v-card-text class="pb-0">
            <v-form class="mt-6">
                <v-textarea
                    v-model="value.comment"
                    type="number"
                    :label="t('user_label_comment')"
                    required
                    outlined
                    dense
                    :error-messages="form.errors.get('comment')"
                ></v-textarea>
            </v-form>
        </v-card-text>

        <v-card-actions>
            <v-btn
                color="primary"
                @click="submit"
                width="45%"
                :loading="form.busy"
                :disabled="form.busy"
            >{{ t('general_action_save') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
                color="orange"
                @click="cancel"
                width="45%"
                dark
            >{{ t('general_action_cancel') }}</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
